var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value == 0)?_c('i',{staticClass:"fas fa-door-closed fa-2x"}):_vm._e(),(_vm.value == 1)?_c('i',{staticClass:"fas fa-door-open fa-2x"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }